import * as React from "react";
import ProjectDetails from "./ProjectDetails";
const galleryImages = [{
  id: 1,
  src: "https://ksluxury.cloudtech.com.cy/wp-content/uploads/2026/03/Leukothea-2.jpg?v=5ivjvsq9c45",
  alt: "Pareklisia residence exterior view"
}, {
  id: 2,
  src: "https://ksluxury.cloudtech.com.cy/wp-content/uploads/2026/03/Leukothea-1.jpg?v=nsoy741k2h",
  alt: "Interior living room renovation"
}];
export default function ProjectHeroImage() {
  return <section id="project-hero-image" className="bg-[#fff] py-12">
      <div className="w-full px-8 max-w-[1920px] mx-auto">
        <h1 className="text-center font-bold mb-10 !text-[27px]">Leukothea Office Construction</h1>
        <ProjectDetails />
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {galleryImages.map((image, i) => <div key={image.id} data-index={i} className="overflow-hidden rounded-[0.5rem] bg-muted/20">
              <img src={image.src} alt={image.alt} className="w-full h-full object-cover aspect-[4/3] transition-transform duration-500 hover:scale-105" loading={i < 3 ? "eager" : "lazy"} />
            </div>)}
        </div>
      </div>
    </section>;
}